import { useMutation } from "react-query";
import http from "infra/http";

function useConciliarExtrato() {
  return useMutation(
    ({
      extratoId,
      contas,
      transferenciaId,
    }: {extratoId: string; contas?: string[]; transferenciaId?: string}) => {
      return http.post(`/v1/extrato-bancario/${extratoId}/conciliar`, {
        contas,
        transferenciaId,
      });
    },
    { retry: false }
  );
}

export default useConciliarExtrato;
